import { IonButton, IonIcon, IonRouterLink } from '@ionic/react';
import React from 'react';

import ButtonContainer from '@/components/common/buttonContainer/ButtonContainer';
import Spacer from '@/components/common/spacer/Spacer';
import RequestSummary from '@/components/summary/requestSummary/RequestSummary';
import { useLanguage } from '@/contexts/LanguageContext';
import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import useToast from '@/hooks/useToast';
import { checkmarkCircleOutline, checkmarkDone } from 'ionicons/icons';

import './ThankYou.css';

const ThankYou: React.FC = () => {
  const { t } = useLanguage();
  const {
    clinic,
    selectedDentist: dentist,
    patient,
    request,
    durationInMinutes,
    reset: onReset
  } = useScheduleFlow();
  const displayToast = useToast();

  const copy = {
    subHeader: t('schedule.thankYou.subHeader'),
    header: t('schedule.thankYou.header'),
    message: t('schedule.thankYou.message'),
    buttonText: t('schedule.thankYou.buttonText'),
    startOverPrompt: t('schedule.thankYou.startOverPrompt'),
    startOverText: t('schedule.thankYou.startOverText'),
    toastMessage: t('schedule.thankYou.toastMessage')
  };

  const onDone = () => {
    displayToast({
      message: copy.toastMessage,
      duration: 5000,
      position: 'bottom',
      positionAnchor: 'doneButton'
    });
  };

  if (!clinic) return null;

  return (
    <div id="thankYou">
      <IonIcon color="primary" icon={checkmarkDone} id="thankYouIcon" />
      <h4 id="subHeader">{copy.subHeader}</h4>
      <h1 id="header">{copy.header}</h1>
      <p id="message">{copy.message}</p>
      <Spacer top={24} />
      <RequestSummary
        clinic={clinic}
        dentist={dentist}
        patient={patient}
        request={request}
        durationInMinutes={durationInMinutes}
      />
      <Spacer top={16} bottom={102}>
        <div id="startOver">
          <p>{copy.startOverPrompt}</p>
          <IonRouterLink onClick={onReset}>{copy.startOverText}</IonRouterLink>
        </div>
      </Spacer>
      <ButtonContainer>
        <IonButton
          id="doneButton"
          onClick={onDone}
          expand="block"
          fill="solid"
          size="default"
        >
          <IonIcon slot="start" icon={checkmarkCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
      </ButtonContainer>
    </div>
  );
};

export default ThankYou;
